import { render, staticRenderFns } from "./PageLoginToken.vue?vue&type=template&id=f5eeb56e&"
import script from "./PageLoginToken.vue?vue&type=script&lang=ts&"
export * from "./PageLoginToken.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports